import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class FaultsService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getReasons() {
        let sessionid = this.authService.getSessionId();
        return this.api.get('faults/reasons', { headers: { authorization: sessionid } }).then(r => r.data);
    }

    createFault(data) {
        let sessionid = this.authService.getSessionId();
        return this.api.post('faults', data, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    getFaults(filters = {}) {
        let sessionid = this.authService.getSessionId();
        return this.api.get('faults', { 
            headers: { authorization: sessionid },
            params: filters
        }).then(r => r.data);
    }

    toggleSync(id) {
        let sessionid = this.authService.getSessionId();
        return this.api.put(`faults/${id}/toggle-sync`, {}, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    resolve(id) {
        let sessionid = this.authService.getSessionId();
        return this.api.put(`faults/${id}/resolve`, {}, { headers: { authorization: sessionid } }).then(r => r.data);
    }
}

export default FaultsService;
